import Authorization from '../Authentication/Authorization'
import Apps from '../pages/apps/Apps'
import BGSchedule from '../pages/bgexecution/BGSchedule'
import Dashboard from '../pages/Dashboard'
import GatewayType from '../pages/GatewayType'
import Info from '../pages/info/Info'
import Keys from '../pages/keystore/Keys'
import Services from '../pages/services/Services'
import Settings from '../pages/settings/Settings'
import Tls from '../pages/tls/Tls'
import TokenProfiles from '../pages/tokenprofiles/TokenProfiles'
import UserManagement from '../pages/usermanagement/UserManagement'
const servicesPermission: string[] = Array.from(
  new Set([...Object.values(Authorization.services.webServices), ...Object.values(Authorization.services.proxies)].flat())
)

const infoPermission: string[] = Array.from(new Set([...Object.values(Authorization.info.database), ...Object.values(Authorization.info.version)].flat()))

const settingsPermission: string[] = Array.from(
  new Set(
    [
      ...Object.values(Authorization.settings.changeRequest),
      ...Object.values(Authorization.settings.advancedSettings),
      ...Object.values(Authorization.settings.license),
      ...Object.values(Authorization.settings.masterKey),
      ...Object.values(Authorization.settings.solrConfig),
      ...Object.values(Authorization.settings.syslogIntegration),
      ...Object.values(Authorization.settings.o365Setting),
    ].flat()
  )
)

const userManagementPermission: string[] = Array.from(
  new Set(
    [
      ...Object.values(Authorization.userManagement.administration),
      ...Object.values(Authorization.userManagement.passwordPolicy),
      ...Object.values(Authorization.userManagement.activeDirectory),
      ...Object.values(Authorization.userManagement.adMapping),
      ...Object.values(Authorization.userManagement.policyUsers),
    ].flat()
  )
)

const keystorePermission: string[] = Array.from(
  new Set(
    [
      ...Object.values(Authorization.keystore.keys),
      ...Object.values(Authorization.keystore.keyRotation),
      ...Object.values(Authorization.keystore.trustedTLSIssuer),
    ].flat()
  )
)

const tlsPermission: string[] = Array.from(
  new Set([...Object.values(Authorization.keystore.keys), ...Object.values(Authorization.keystore.trustedTLSIssuer)].flat())
)

export const routes = [
  createRoute('/', 'Dashboard', Dashboard, Authorization.dashboard),
  createRoute('/services', 'Services', Services, servicesPermission),
  createRoute('/apps', 'Apps', Apps, Authorization.apps.view),
  createRoute('/bgexecution', 'Jobs', BGSchedule, Authorization.bgSchedule.view),
  createRoute('/keys', 'Keys', Keys, keystorePermission),
  createRoute('/tls', 'TLS', Tls, tlsPermission),
  createRoute('/tokenProfile', 'Token Profile', TokenProfiles, Authorization.tokenprofiles.view),
  createRoute('/userManagement', 'User Management', UserManagement, userManagementPermission),
  createRoute('/setting', 'Settings', Settings, settingsPermission),
  createRoute('/info', 'Info', Info, infoPermission),
]

function createRoute(path: string, title: string, content: GatewayType, permissions: string[]) {
  return { path, title, content, permissions }
}
